import { AuthContext } from '../../contexts/AuthContext/definition'
import { Button, Layout, theme } from 'antd'
import { MenuFoldOutlined, MenuUnfoldOutlined } from '@ant-design/icons'
import { ReactNode, useContext } from 'react'

import { SupplementalLinkType } from '../../types'

import styles from './index.module.css'

const { Header } = Layout

export interface LayoutHeaderProps {
  collapsed: boolean
  onClickCollapse: () => void
  showMenuToggle?: boolean
  pageTitle?: string | null
  pageTitleIcon?: string | null
  reportLink?: string | null
  supplementalLink?: SupplementalLinkType | null
  children: ReactNode
}

const LayoutHeader = ({
  collapsed,
  onClickCollapse,
  showMenuToggle,
  pageTitle,
  pageTitleIcon,
  reportLink,
  supplementalLink,
  children,
}: LayoutHeaderProps) => {
  const { session } = useContext(AuthContext)
  const {
    token: { colorBgContainer },
  } = theme.useToken()

  return (
    <Header
      className={styles.layoutHeader}
      style={{ background: colorBgContainer }}
    >
      <div className={styles.container}>
        <div className={styles.headerLeft}>
          {showMenuToggle && (
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={onClickCollapse}
              style={{
                fontSize: '16px',
                width: 64,
                height: 64,
              }}
            />
          )}
          {!showMenuToggle && <div></div>}
          {pageTitle && (
            <>
              {pageTitleIcon && (
                <div
                  className={styles[pageTitleIcon ? pageTitleIcon : '']}
                ></div>
              )}
              <div className={styles.pageTitle}>{pageTitle}</div>
            </>
          )}
          <div className={styles.headerLinks}>
            {reportLink && (
              <div className={styles.reportLinkContainer}>
                <span className={styles.reportLink}>
                  <a
                    href={reportLink}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Report an Issue
                  </a>
                </span>
              </div>
            )}

            {supplementalLink && (
              <div className={styles.supplementalLinkContainer}>
                <span className={styles.supplementalLink}>
                  <a
                    href={supplementalLink.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {supplementalLink.icon} {supplementalLink.text}
                  </a>
                </span>
              </div>
            )}
          </div>
        </div>
        <div className={styles.headerRight}>
          {children}
          {session && <div className={styles.profile}>{session?.email}</div>}
        </div>
      </div>
    </Header>
  )
}

export default LayoutHeader
